import { render, staticRenderFns } from "./PlantingSocCoordinateEdit.vue?vue&type=template&id=68468dab"
import script from "./PlantingSocCoordinateEdit.vue?vue&type=script&lang=js"
export * from "./PlantingSocCoordinateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports